import React from "react";
import TopMenu from "./TopMenu";

export default function Dashboard() {
  return (
    <div>
      <TopMenu />
    </div>
  );
}
